
export {PlayerManager};

import {e} from './utils.js';
import {BackwardButton, ForwardButton, GoEndButton, GoStartButton, PauseButton, PlayButton} from './buttons.js';
import {ytplayerState} from './ytplayer.js';

// -------------------------
// PLAYER MANAGER
// -------------------------

function PlayerManager() {

	// ----------------------------
	// Properties
	// ----------------------------

	var bStart     = GoStartButton(60, 40, this);
	var bBack15    = BackwardButton(60, 40, "15", 3, this);
	var bBack5     = BackwardButton(60, 40, "5", 2, this);
	var bPause     = PauseButton(60, 40, this);
	var bPlay      = PlayButton(60, 40, this);
	var bForward5  = ForwardButton(60, 40, "5", 2, this);
	var bForward15 = ForwardButton(60, 40, "15", 3, this);
	var bEnd       = GoEndButton(60, 40, this);

	bPause.style.visbility = "hidden";
	bPause.style.display   = "none";

	e("player_controls").appendChild(bStart);
	e("player_controls").appendChild(bBack15);
	e("player_controls").appendChild(bBack5);
	e("player_controls").appendChild(bPause);
	e("player_controls").appendChild(bPlay);
	e("player_controls").appendChild(bForward5);
	e("player_controls").appendChild(bForward15);
	e("player_controls").appendChild(bEnd);


	// ----------------------------
	// Functions
	// ----------------------------

	this.play_video  = f_play_video;
	this.pause_video = f_pause_video;
	this.play_clip   = f_play_clip;
	this.pause_clip  = f_pause_clip;
	this.stop_clip   = f_stop_clip;
	this.go_to       = f_go_to;
	this.go_start    = f_go_start;
	this.go_end      = f_go_end;
	this.clear_video = f_clear_video;
	this.clicked     = f_clicked;


	// ----------------------------
	// Methods
	// ----------------------------

	function f_play_video() {
		if (ytplayerState.yt_player && ytplayerState.yt_player.playVideo){
			ytplayerState.yt_player.playVideo();
		}
		bPlay.style.visibility  = "hidden";
		bPlay.style.display     = "none";
		bPause.style.visibility = "visible";
		bPause.style.display    = "block";
	}

	function f_pause_video() {
		if (ytplayerState.yt_player && ytplayerState.yt_player.pauseVideo){
			ytplayerState.yt_player.pauseVideo();
		}
		bPause.style.visibility  = "hidden";
		bPause.style.display     = "none";
		bPlay.style.visibility   = "visible";
		bPlay.style.display      = "block";
	}

	function f_play_clip(ytid, start, duration) {
		console.log("PLAY CLIP: " + ytid + " start: " + start + " duration: " +  duration + " end: " + ytplayerState.yt_clip_end);
		if (!ytplayerState.yt_player) {
			return;
		}

		// If a clip is already playing, check if new clip begins after beginning of current clip
		// and before end of current clip.  If so, continue playing with new clips end time,
		// otherwise clear the duration monitor
		if (ytplayerState.yt_clip_playing === true) {
			if (ytplayerState.yt_clip_id === ytid && start > ytplayerState.yt_clip_start && start < ytplayerState.yt_clip_end) {
				ytplayerState.yt_clip_end = start + duration;
				return;
			} else {
				window.clearInterval(ytplayerState.yt_clip_monitor);
			}
		}

		// Set the current clip properties
		ytplayerState.yt_clip_start   = start;
		ytplayerState.yt_clip_end     = ytplayerState.yt_clip_start + duration;
		ytplayerState.yt_clip_playing = true;

		// Check if a new video
		if (ytplayerState.yt_clip_id != ytid) {
			ytplayerState.yt_clip_id = ytid;
			ytplayerState.yt_player.loadVideoById({
				'videoId' : ytplayerState.yt_clip_id,
				'startSeconds' : ytplayerState.yt_clip_start,
				'suggestedQuality': 'large'
			});
		} else {
			ytplayerState.yt_player.seekTo(ytplayerState.yt_clip_start, true);
		}

		// Start playing the video
		ytplayerState.yt_player.playVideo();

		// Monitor the duration
		ytplayerState.yt_clip_monitor = window.setInterval(f_pause_clip, 250);
	}

	function f_pause_clip() {
		if (ytplayerState.yt_player.getCurrentTime() > ytplayerState.yt_clip_end) {
			ytplayerState.yt_player.pauseVideo();
			ytplayerState.yt_clip_playing = false;
			window.clearInterval(ytplayerState.yt_clip_monitor);
		}
	}

	function f_stop_clip() {
		ytplayerState.yt_player.stopVideo();
		ytplayerState.yt_clip_playing = false;
		window.clearInterval(ytplayerState.yt_clip_monitor);
	}

	function f_go_to(ytid, n) {
		// Return if youtube player not ready
		if (! ytplayerState.yt_player) {
			return;
		}

		n = Math.max(0, Math.min(n, ytplayerState.yt_player.getDuration()));

		if (ytplayerState.yt_clip_id != ytid) {
			ytplayerState.yt_clip_id = ytid;
			ytplayerState.yt_player.loadVideoById({
				'videoId' : ytplayerState.yt_clip_id,
				'startSeconds' : n,
				'suggestedQuality': 'large'
			});
		} else {
			ytplayerState.yt_player.seekTo(n, true);
		}

		f_pause_video();
	}

	function f_go_start() {
		f_pause_video();
		ytplayerState.yt_player.seekTo(0, true);
	}

	function f_go_end() {
		f_pause_video();
		ytplayerState.yt_player.seekTo(ytplayerState.yt_player.getDuration(), true);
	}

	function f_clear_video() {
		ytplayerState.yt_player.clearVideo();
	}


	// ----------------------------
	// Event Handlers
	// ----------------------------

	function f_clicked(b) {

		let currentTime = ytplayerState.yt_player.getCurrentTime();

		switch (b) {
			case bStart:     f_go_start(); break;
			case bBack15:    ytplayerState.yt_player.seekTo(Math.max(0, currentTime - 15), true); break;
			case bBack5:     ytplayerState.yt_player.seekTo(Math.max(0, currentTime - 5), true); break;
			case bPlay:      f_play_video(); break;
			case bPause:     f_pause_video(); break;
			case bForward5:  ytplayerState.yt_player.seekTo(currentTime + 5, true); break;
			case bForward15: ytplayerState.yt_player.seekTo(currentTime + 15, true); break;
			case bEnd:       f_go_end(); break;
		}
	}
}

